import { components } from 'type/ReportServiceSchema';
import {
  InsightsQuestionModel,
  mapInsightsQuestionDtoToModel,
} from 'api/dto/new/InsightsCompared/InsightsQuestion.dto';
import {
  InsightsAnswerModel,
  mapInsightsAnswerDtoToModel,
} from 'api/dto/new/InsightsCompared/InsightsAnswer.dto';
import { RespondentProtectionEnumNullable } from 'model/RespondentProtection';

export type InsightsItemDto = components['schemas']['InsightsItemDTO'];

export type InsightsItemModel = Readonly<{
  question: InsightsQuestionModel;
  answers: ReadonlyArray<InsightsAnswerModel>;
}>;

export const mapInsightsItemDtoToModel = (
  dto: InsightsItemDto,
  protections: Record<string | number, RespondentProtectionEnumNullable> = {}
): InsightsItemModel => ({
  question: mapInsightsQuestionDtoToModel(dto.question),

  answers: dto.answers.map((answer) => mapInsightsAnswerDtoToModel(answer, protections)),
});
